import React, {useState} from "react";
import {Button} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Article} from "../../../../../models/articles/article";
import {articlesService} from "../../../../../services/articles/articles.service";
import {ArticleCardPopup} from "../../../../article/article-card-popover/catalog.card.popup";
import {CartCreateType} from "../../../../../models/cart/create/cart.create";

interface ArticleSimple {
    id: number;
    inCartQty: number;
    multiple: number;
}

interface AddToCartSimpleProps {
    article: ArticleSimple;
    type?: CartCreateType;
}

export const AddToCartAction: React.FC<AddToCartSimpleProps> = ({article, type = "regular"}) => {

    const [popupVisible, setPopupVisible] = useState<boolean>(false);

    const [qty, setQty] = useState<number>(article.inCartQty);

    const addToCart = (article: Article, qty: number) => {
        return {
            client: () => setQty(qty),
            back: () => articlesService.addToCart({ article: article.id, qty, type: type }),
        };
    };

    const deleteFromCart = (article: Article) => {
        return {
            client: () => setQty(0),
            back: () => articlesService.removeFromCart(article.id),
        };
    };

    return (
        <div style={{position: "relative"}}>
            {popupVisible ? (
                <ArticleCardPopup
                    article={article}
                    addToCart={addToCart}
                    deleteFromCart={deleteFromCart}
                    inCartQty={qty}
                    close={() => setPopupVisible(false)}
                    style={{top: 32, left: 0}}
                />
            ) : null}
            <Button
                className={"article_cart-btn" + (qty > 0 ? " in-cart" : "")}
                icon={<FontAwesomeIcon style={{marginRight: 8}} icon={["fas", "shopping-cart"]}/>}
                onMouseDown={() => {
                    if (!popupVisible) {
                        setPopupVisible(true);
                    }
                }}
            >
                {qty}
            </Button>
        </div>

    )
}